<template>
  <div class="achievements">
    <navbar/>
    <div class="achievementSlides">
      <div class="slider" id="slideAchievements">
        <ul class="slides">
          <li>
            <img src="../../assets/logBg.png" alt="">
            <div class="caption center-align">
              <h3 class=" white-text">Platinum Minds Global Company</h3>
            </div>
          </li>
          <li>
            <img src="../../assets/programs/top-winners.jpg">
            <div class="caption center-align">
              <h3>The top winners of PRC 2017</h3>
              <h4>Oluwafemi Bankole, Abdulsalam folasewa and Salisu Ahmad</h4>
            </div>
          </li>
          <li>
            <img src="../../assets/programs/prc2017.jpg">
            <div class="caption right-align">
              <h3>The top winners with some of the executives</h3>
            </div>
          </li>
          <li>
            <img src="../../assets/programs/ag.jpg">
            <div class="caption left-align">
              <h3>AG's FMC</h3>
              <h4>Awarding winners of AG Fantastic Mathematics Competition</h4>
            </div>
          </li>
          <li>
            <img src="../../assets/programs/ag2.jpg">
            <div class="caption right-align">
              <h3>AG's FMC</h3>
              <h4>Awarding winners of AG Fantastic Mathematics Competition</h4>
            </div>
          </li>
          <li>
            <img src="../../assets/programs/prc20172.jpg">
            <div class="caption left-align">
              <h3>PRC2017 Grand finale ceremony</h3>
              <h4>At Transcorp Hilton, Abuja</h4>
            </div>
          </li>
          <li>
            <img src="../../assets/programs/ag2.jpg">
            <div class="caption right-align">
              <h3>AG's FMC</h3>
              <h4>Awarding winners of AG Fantastic Mathematics Competition</h4>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="ag row" id="agFMC">
      <div class="card-image">
        <h3 class="header center-align">AG FMC</h3>
        <div class="col s12 m8 offset-m2">
          <div class="card-panel grey-text text-darken-3">
            <img src="../../assets/programs/ag.jpg" class="responsive-img" style="width: 100%;">
            <span>
              <p>
                Our past accomplishment. This group has successfully organized a mathematics competition for secondary schools in Nigeria .Reality School from Ilesha Osun State came first in  all the category . Check our gallery for the picture of the this event .
              </p>
              <a class="btn blue-grey">Held at</a> Finger Licking Comapny.<br/><br/><br class="show-on-small-only hide-on-med-and-up"/>
              <a class="btn blue-grey">Date</a> 2013-11-15
            </span>
          </div>
        </div>
      </div>
    </div>
    <br/>
    <div class="prc row" id="prc2017">
      <div class="card-image">
        <h3 class="header center-align">Platinum Reasoning Contest 2017</h3>
        <div class="col s12 m8 offset-m2">
          <div class="card-panel grey-text text-darken-3">
            <img src="../../assets/programs/prc20172.jpg" class="responsive-img" style="width: 100%;">
            <span>
              <p>
                Our achievement as at 2017. The Platinum Mathematics team has successfully organized a contest tagged "Platinum Reasoning Contest" #prc2017. The plan to organize this contest started as at 2015 and was successfully accomplished last year(2017).
              </p>
              <a class="btn blue-grey">Held at</a> Transcort Hilton, Abuja.<br/><br/><br class="show-on-small-only hide-on-med-and-up"/>
              <a class="btn blue-grey">Date</a> 2017-11-18
            </span>
          </div>
        </div>
      </div>
    </div>
    <footer-page/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
import FooterPage from '@/components/layouts/footer-page'
import M from 'materialize-css'
import $ from 'jquery'
export default {
  components: {Navbar, FooterPage},
  mounted () {
    $('div.achievements #slideAchievements > ul.slides > li > img').addClass('materialboxed')
    var elem = document.querySelector('#slideAchievements')
    // eslint-disable-next-line
    var instance = new M.Slider(elem, {
      indicators: false
    })

    var el = document.querySelector('.materialboxed')
    // eslint-disable-next-line
    var instance = new M.Materialbox(el, {})
  }
}
</script>

<style>
  div.achievements #slideAchievements > ul.slides > li > img {
    filter: brightness(.6);
    height: 100%;
    width: 100%;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/pmgc/achievements/index.vue